import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useTrashManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const moveToTrash = async (ideaId: string, source: 'scraped' | 'user_generated') => {
    setIsLoading(true);
    try {
      const tableName: 'user_generated_content' | 'content_ideas' = source === 'user_generated' ? 'user_generated_content' : 'content_ideas';
      
      const { error } = await supabase
        .from(tableName)
        .update({
          is_trashed: true,
          trashed_at: new Date().toISOString()
        })
        .eq('id', ideaId);

      if (error) {
        console.error('Error moving to trash:', error);
        toast({
          title: "Błąd",
          description: "Nie udało się przenieść do kosza",
          variant: "destructive",
        });
        return false;
      }

      toast({
        title: "Przeniesiono do kosza",
        description: "Pomysł został przeniesiony do kosza",
      });
      return true;
    } catch (error) {
      console.error('Error in moveToTrash:', error);
      toast({
        title: "Błąd",
        description: "Wystąpił nieoczekiwany błąd",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const restoreFromTrash = async (ideaId: string, source: 'scraped' | 'user_generated') => {
    setIsLoading(true);
    try {
      const tableName: 'user_generated_content' | 'content_ideas' = source === 'user_generated' ? 'user_generated_content' : 'content_ideas';
      
      const { error } = await supabase
        .from(tableName)
        .update({
          is_trashed: false,
          trashed_at: null
        })
        .eq('id', ideaId);

      if (error) {
        console.error('Error restoring from trash:', error);
        toast({
          title: "Błąd",
          description: "Nie udało się przywrócić z kosza",
          variant: "destructive",
        });
        return false;
      }

      toast({
        title: "Przywrócono",
        description: "Pomysł został przywrócony",
      });
      return true;
    } catch (error) {
      console.error('Error in restoreFromTrash:', error);
      toast({
        title: "Błąd",
        description: "Wystąpił nieoczekiwany błąd",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    moveToTrash,
    restoreFromTrash,
    isLoading
  };
};
